import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, DollarSign } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-16">
      {/* Background subtle pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-10 w-72 h-72 bg-accent rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 bg-accent text-accent-foreground px-4 py-1.5 rounded-full text-sm font-medium mb-8"
          >
            <BadgeCheck className="w-4 h-4" />
            Save up to 40% on vacation rentals
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="font-display text-5xl md:text-7xl font-bold tracking-tight leading-[1.1] mb-6"
          >
            Skip the middleman.{" "}
            <span className="text-gradient-primary">Book direct.</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed"
          >
            Paste any Airbnb listing and we'll find the host's direct website — 
            so you can book the same property for less.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <Link
              to="/search"
              className="group bg-gradient-hero text-primary-foreground px-8 py-4 rounded-xl text-base font-semibold hover:opacity-90 transition-all shadow-savings flex items-center gap-2"
            >
              Find Direct Prices
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href="#how-it-works"
              className="px-8 py-4 rounded-xl text-base font-semibold border bg-card hover:bg-secondary transition-colors"
            >
              How it Works
            </a>
          </motion.div>

          {/* Savings stat */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="mt-16 inline-flex items-center gap-6 bg-card border rounded-2xl px-8 py-5 shadow-card-hover"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center">
                <DollarSign className="w-5 h-5 text-accent-foreground" />
              </div>
              <div className="text-left">
                <p className="text-2xl font-display font-bold text-foreground">$127</p>
                <p className="text-xs text-muted-foreground">Avg. savings per booking</p>
              </div>
            </div>
            <div className="w-px h-10 bg-border" />
            <div className="text-left">
              <p className="text-2xl font-display font-bold text-savings">12,400+</p>
              <p className="text-xs text-muted-foreground">Direct links found</p>
            </div>
            <div className="w-px h-10 bg-border" />
            <div className="text-left">
              <p className="text-2xl font-display font-bold text-foreground">4.9★</p>
              <p className="text-xs text-muted-foreground">User rating</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
